import { useState } from 'react';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    // Honeypot check
    const honeypot = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypot && honeypot.value.trim() !== '') {
      setFormStatus('success');
      setFormMessage('提交成功，我们会尽快回复！');
      form.reset();
      return;
    }

    setFormStatus('loading');
    setFormMessage('');

    try {
      const formData = new FormData(form);
      // Remove honeypot before sending
      formData.delete('website_alt');

      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value.toString());
      });

      const response = await fetch('https://readdy.ai/api/form/d9m7mkkit35ii3jdlft0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('提交成功，我们会尽快回复！');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormStatus('error');
          setFormMessage('提交失败，请稍后重试');
        } else {
          setFormStatus('error');
          setFormMessage(serverMsg);
        }
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查网络连接后重试');
    }
  };

  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            有任何问题、建议或投稿需求，欢迎随时与我们取得联系
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-mail-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                  <p className="text-sm text-foreground-600">contact@777cinema.com</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-accent-100 rounded-lg">
                  <i className="ri-time-line text-accent-600"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">响应时间</p>
                  <p className="text-sm text-foreground-600">工作日 24 小时内回复</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-secondary-100 rounded-lg">
                  <i className="ri-chat-3-line text-secondary-600"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">投稿合作</p>
                  <p className="text-sm text-foreground-600">欢迎优质内容创作者联系</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-lg">
                  <i className="ri-error-warning-line text-primary-500"></i>
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">问题反馈</p>
                  <p className="text-sm text-foreground-600">遇到问题请详细描述</p>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="visually-hidden-field"
              />
              <div>
                <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                  您的称呼
                </label>
                <input
                  id="contact-name"
                  name="name"
                  type="text"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all text-foreground-900"
                  placeholder="请输入您的名字"
                />
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                  电子邮箱
                </label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all text-foreground-900"
                  placeholder="请输入您的邮箱地址"
                />
              </div>
              <div>
                <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">
                  主题
                </label>
                <select
                  id="contact-subject"
                  name="subject"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all text-foreground-900 cursor-pointer"
                >
                  <option value="">请选择主题</option>
                  <option value="问题反馈">问题反馈</option>
                  <option value="内容投稿">内容投稿</option>
                  <option value="商务合作">商务合作</option>
                  <option value="其他咨询">其他咨询</option>
                </select>
              </div>
              <div>
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                  留言内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-200 rounded-lg focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all text-foreground-900 resize-none"
                  placeholder="请输入您的留言内容（500字以内）"
                ></textarea>
              </div>

              {formStatus !== 'idle' && (
                <div
                  className={`text-sm p-3 rounded-lg ${
                    formStatus === 'success'
                      ? 'bg-accent-100 text-accent-800 border border-accent-200'
                      : formStatus === 'error'
                      ? 'bg-primary-100 text-primary-700 border border-primary-200'
                      : 'bg-secondary-100 text-secondary-700 border border-secondary-200'
                  }`}
                >
                  {formStatus === 'loading' ? '正在提交...' : formMessage}
                </div>
              )}

              <button
                type="submit"
                disabled={formStatus === 'loading'}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-400 text-background-50 font-medium rounded-lg transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
              >
                {formStatus === 'loading' ? '提交中...' : '发送留言'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}